// getters
const getters = {
  getLanguage: (state) => state.language,
  getHomepageBanner: (state) => state.homepageBanner,
  getHomepageFeatureExcellences: (state) => state.homepageFeatureExcellences,
  getHomepageFlow: (state) => state.homepageFlow,
  getHomepageRegistrationButton: (state) => state.homepageRegistrationButton,
  getRegistration: (state) => state.registration,
};

export default getters;
